var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticesOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35002 12.21H16.95M5.35002 15.77H14.37M17.11 8.22999L11.14 2.37999L4.85002 8.22999M18.98 21.19H3.33002C2.13002 21.19 1.15002 20.21 1.15002 19.01V10.41C1.15002 9.20999 2.13002 8.22999 3.33002 8.22999H18.98C20.18 8.22999 21.16 9.20999 21.16 10.41V19.01C21.16 20.21 20.18 21.19 18.98 21.19ZM11.15 1.14999C10.47 1.14999 9.92002 1.69999 9.92002 2.37999C9.92002 3.05999 10.47 3.60999 11.15 3.60999C11.83 3.60999 12.38 3.05999 12.38 2.37999C12.38 1.69999 11.83 1.14999 11.15 1.14999Z",
    stroke: "#FF43AA",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticesOn);
export default __webpack_public_path__ + "static/media/noticesOn.92345ed32d7a0499dd7b4f75ce62375d.svg";
export { ForwardRef as ReactComponent };